<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/ruanqidong" />
          <div class="ProductImages">
              <div class="image-div">
                <img :src="baseApi+ 'upload/product/3001.png'">
                <div style="width: 10%"></div>
                <img :src="baseApi+ 'upload/product/3002.png'">
              </div>
            <img style="width: 100%" :src="baseApi+ 'upload/product/3003.png'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  padding: 30px;
  .image-div {
    display: flex;
    margin: 10px;
    img {
      width: 45%;
      margin: 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/ruanqidong.vue